import React from "react";

function Header() {
  return (
    <header className="header">
      <div className="container">
        <h1>ReHo〽️e</h1>
        <nav>
          <ul>
            <li><a href="#hero">Home</a></li>
            <li><a href="#adopt">About Us</a></li>
            <li><a href="#how-it-works">How It Works</a></li>
            <li><a href="upi://pay?pa=7001072985@axl&pn=abhay&cu=INR&am">Donate</a></li>
            <li><a href="#get-involved">Get Involved</a></li>
            <li><a href="#footer">Contact Us</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
